import { render, staticRenderFns } from "./static-content-wrapper.vue?vue&type=template&id=733e177f&scoped=true&"
import script from "./static-content-wrapper.vue?vue&type=script&lang=js&"
export * from "./static-content-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./static-content-wrapper.vue?vue&type=style&index=0&id=733e177f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733e177f",
  null
  
)

export default component.exports